import { useQuery } from '@tanstack/react-query';

import {
  AllowedActions,
  EventFormStatus,
  ReportType,
  MetadataClient,
  ProblemDetails,
} from '../../clients';
import queryKeys from '../../queryKeys';

import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);

function useGetAllowedActions(
  formCreatorId: string | null | undefined,
  formStatus: EventFormStatus | undefined,
  reportType: ReportType | undefined,
) {
  return useQuery<AllowedActions, ProblemDetails>({
    queryKey: [queryKeys.Metadata.AllowedActions, {
      formCreatorId,
      formStatus,
      reportType,
    }],
    queryFn: () => metadataClient.getAllowedFormActions(
      reportType,
      formCreatorId,
      formStatus,
    ),
  });
}

export default useGetAllowedActions;
